import {Spinner} from "@/components/ui/Spinner.tsx";

export function LoadOverlay() {
    return (
        <>
            <div className={`os-app-row os-flex os-flex-col os-gap-4 os-w-full os-items-center os-bg-white os-p-12`}>
                <Spinner className="os-h-12 os-w-12" />
            </div>
        </>
    );
}